import { render, staticRenderFns } from "./exchangeRateSet.vue?vue&type=template&id=08486698&scoped=true"
import script from "./exchangeRateSet.vue?vue&type=script&lang=js"
export * from "./exchangeRateSet.vue?vue&type=script&lang=js"
import style0 from "./exchangeRateSet.vue?vue&type=style&index=0&id=08486698&prod&scoped=true&lang=scss"
import style1 from "./exchangeRateSet.vue?vue&type=style&index=1&id=08486698&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08486698",
  null
  
)

export default component.exports